import * as React from 'react';
import { useTranslation } from 'react-i18next';

// Utils
import { isNil } from '@src/shared/src/util/general';
// Constants
import { VEHICLE_TYPES } from '@src/shared/src/const/app';
// Models
import { GroundTransportModel } from '@src/shared/src/models';
// Styles
import './styles/GroundTransportBadge.scss';

// The translations live at locize, not in this repo, so each label carries the English
// word as its default: a key that has not been added there yet reads as a mode rather
// than as a key, while `missingKeyHandler` still reports it
const LABELS = {
  [VEHICLE_TYPES.BUS]: { key: 'transportSegment.label.groundTransport.bus', fallback: 'Bus' },
  [VEHICLE_TYPES.TRAIN]: { key: 'transportSegment.label.groundTransport.train', fallback: 'Train' },
};

type Props = {
  groundTransport?: GroundTransportModel;
};

// Marks a segment that is sold under a flight number but operated as a bus or a
// train. Everything else about the segment (icon, logo, flight number, filters)
// keeps behaving like the flight it is sold as, so this badge is purely additive.
export const GroundTransportBadge: React.FC<Props> = ({ groundTransport }) => {
  const { t } = useTranslation();
  const label = LABELS[groundTransport?.vehicle];

  // No badge without a ground transport, and none for a mode we have no label for
  if (isNil(label)) {
    return null;
  }

  return (
    <span className="ground-transport-badge">
      {t(label.key, { defaultValue: label.fallback })}
    </span>
  );
};
